<template>
    <div class="container">
        <div class="banner row justify-center items-center image" v-if="img" @click="$watchContent(item)">
            <v-img :item="item" :img="img" :key="img.url"/>
        </div>
    </div>
</template>

<script>
    import watchContent from '../../plugins/watchContent'

    export default {
        name: 'VBanner',

        props: {
            img: {
                type: Object,
                required: true
            },
            item: ''
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/front/Banner.vue